/* eslint-disable no-unused-vars */
import React, { Fragment, useState } from 'react'
import ElementContainer from '../ElementContainer'
import {
  Box,
  Button,
  ButtonBase,
  IconButton,
  ImageList,
  ImageListItemBar,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile } from '@fortawesome/pro-regular-svg-icons'
import imagePlaceholder from '../../../assets/images/imageFilePlaceholder.png'
import { attachmentsElementStyles } from '../../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import { cloneDeep } from '../../../utils/formBuilder'
import { menuProps } from '../../../styles/mui_custom_theme'
import { acceptedFileMimeTypes } from '../../../lib/Constants'

const AttachmentsElement = ({
  title,
  helpfulHint,
  answer,
  onChangeValue,
  attachments,
  isMandatory,
  disabled
}) => {
  const [attachmentsArray, setAttachmentsArray] = useState(answer || [])
  const originalTitles = [...attachments.map(attachment => attachment.title)]
  let selectedTitles = []
  const totalMandatoryAttachments = attachments.filter(attachment => attachment.required).length
  let selectedMandatoryAttachments = 0
  if (attachmentsArray) {
    selectedTitles = attachmentsArray.map(attachment => {
      const originalAttachment = attachments.find(attachmentItem => attachmentItem.title === attachment.title)
      if (originalAttachment.required) selectedMandatoryAttachments++
      return attachment.title
    })
  }
  const attachmentTitles = []
  originalTitles.forEach(title => {
    if (!selectedTitles.includes(title)) attachmentTitles.push(title)
  })
  const [selectedTitle, setSelectedTitle] = useState(null)
  const { classes } = attachmentsElementStyles()
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const imageChangeHandler = e => {
    const files = [...e.target.files]
    const file = files[0]
    const imageUrl = URL.createObjectURL(file)
    const objectToSave = { title: selectedTitle, url: imageUrl }
    if (attachmentsArray) {
      const foundImageIndex = attachmentsArray.findIndex(
        attachment => attachment.title === selectedTitle
      )
      if (foundImageIndex === -1) {
        setAttachmentsArray([...attachmentsArray, objectToSave])
        onChangeValue([...attachmentsArray, objectToSave])
      } else {
        const newAnswer = cloneDeep(attachmentsArray)
        newAnswer[foundImageIndex] = objectToSave
        setAttachmentsArray(newAnswer)
        onChangeValue(newAnswer)
      }
    } else {
      setAttachmentsArray([objectToSave])
      onChangeValue([objectToSave])
    }
    setSelectedTitle(null)
  }

  const imageChangeHandlerAlt = (e, currentTitle) => {
    const files = [...e.target.files]
    const file = files[0]
    const imageUrl = URL.createObjectURL(file)
    const objectToSave = { title: currentTitle, url: imageUrl }
    if (attachmentsArray) {
      const foundImageIndex = attachmentsArray.findIndex(
        attachment => attachment.title === currentTitle
      )
      if (foundImageIndex === -1) {
        onChangeValue([...attachmentsArray, objectToSave])
      } else {
        const newAnswer = cloneDeep(attachmentsArray)
        newAnswer[foundImageIndex] = objectToSave
        onChangeValue(newAnswer)
      }
    } else {
      onChangeValue([objectToSave])
    }
    handleClose()
  }

  const imageInput = () => {
    return (
      <input
        hidden
        accept={acceptedFileMimeTypes.join(',')}
        type="file"
        onChange={imageChangeHandler}
        loading="lazy"
      />
    )
  }

  const imageInputAlt = title => {
    return (
      <input
        hidden
        accept={acceptedFileMimeTypes.join(',')}
        type="file"
        onChange={e => imageChangeHandlerAlt(e, title)}
        loading="lazy"
      />
    )
  }

  const changeSelectHandler = title => {
    setSelectedTitle(title)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const missingAttachments = totalMandatoryAttachments - selectedMandatoryAttachments
  let buttonLabel = t('mobile_preview.add')
  if (attachmentsArray && missingAttachments > 0) {
    if (missingAttachments === 1) {
      buttonLabel = t('mobile_preview.attachments.attachment_required')
    } else {
      buttonLabel = t('mobile_preview.attachments.attachments_required', {
        number: missingAttachments
      })
    }
  }

  return (
    <Fragment>
      <ElementContainer
        title={title}
        helpfulHint={helpfulHint}
        isMandatory={isMandatory}
      >
        <Box className={classes.attachmentsContainer}>
          {!attachmentsArray?.length && (
            <Button
              disableRipple
              className={classes.buttonImagePlaceholder}
              onClick={handleClick}
              disabled={disabled}
            >
              <img
                className={classes.imagePlaceholder}
                src={imagePlaceholder}
                loading="lazy"
              />
              <Typography className={classes.inImagePlaceholderText}>
                {totalMandatoryAttachments > 0 &&
                  t('mobile_preview.attachments.attachments_required', {
                    number: totalMandatoryAttachments
                  })}
              </Typography>
              {imageInput()}
            </Button>
          )}
          {attachmentsArray?.length > 0 && (
            <ImageList>
              {attachmentsArray.map((image, index) => (
                <div key={index}>
                   <img
                className={classes.imagePlaceholder}
                src={imagePlaceholder}
                loading="lazy"
              />
                  <ImageListItemBar
                    title={image?.title}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${image.title}`}
                        component="label"
                        disabled={disabled}
                      >
                        <FontAwesomeIcon icon={faFile} size="lg" />
                        {imageInputAlt(image.title)}
                      </IconButton>
                    }
                  />
                </div>
              ))}
            </ImageList>
          )}
        </Box>
        {!(attachmentTitles.length === 0) && !disabled && (
          <Box className={classes.addButtonContainer}>
            <Box className={classes.addButton} onClick={disabled ? undefined : handleClick}>
              <Typography
                className={`${classes.addButtonText} ${attachmentsArray && missingAttachments > 0 && classes.addButtonTextRed
                  }`}
              >
                {buttonLabel}
              </Typography>
            </Box>
            <Menu
              disabled={disabled}
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={menuProps}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
            >
              {attachmentTitles.map((option, index) => {
                return (
                  <MenuItem
                    className={classes.menuItems}
                    key={`${option}-${index}`}
                    onClick={() => changeSelectHandler(option)}
                  >
                    <ButtonBase
                      fullWidth
                      className={classes.menuButton}
                      component="label"
                    >
                      {option}
                      {imageInput()}
                    </ButtonBase>
                  </MenuItem>
                )
              })}
            </Menu>
          </Box>
        )}
      </ElementContainer>
    </Fragment>
  )
}

export default AttachmentsElement
